<template>
    <div class="jd-video-upload-box">
        <k-row v-for="(item, index) in videoList" :key="index" class="jd-video-upload--item">
            <k-col span="3" class=""><k-icon name="play-circle" size="0.6rem" color="rgb(242, 130, 106)" /></k-col>
            <k-col span="21">
                <div :data-url="item">视频-{{index+1}}<a href="javascript:;" class="fl-right cl-desc" @click="deleteVideo(index)" >删除</a></div>
                <!--<div>
                    <k-progress
                        pivot-text="橙色"
                        :show-pivot="false"
                        color="#f2826a"
                        :percentage="25"
                    />
                </div>-->
            </k-col>
        </k-row>
        <form id="js-uploader_form_videoRidFor" hcbjump="1" enctype="multipart/form-data">
            <!--<k-uploader v-if="videoList.length<2" accept="video/mp4" name="uploadvideo" :max-count="2" :after-read="videoRead" :max-size="maxSize" @oversize="oversize" class="jd-video-upload d-block">
                <k-button icon="live" type="default" class="d-block jd-video-btn">上传视频({{videoList.length}}/{{videoMaxLength}}),最大20m</k-button>
            </k-uploader>-->
            <div class="k-uploader__input-wrapper">
                <k-button icon="live" type="default" block class="jd-video-btn">上传视频({{videoList.length}}/{{videoMaxLength}})，mp4格式，最大20m</k-button>
                <input name="uploadvideo" type="file" accept="video/mp4" @change="videoRead($event)" class="k-uploader__input" />
            </div>
            <input type="hidden" name="modld" value="14" />
            <input type="hidden" name="fileFormat"value="mp4" />
        </form>
    </div>
</template>

<script>
    import {mapActions} from "vuex"
    export default {
        name: "video-upload",
        props : ["list"],
        data() {
            return {
                videoList : this.list || [],
                videoMaxLength : 2,
                uploaded : [],
                maxSize : 20971520 //20m
            }
        },
        methods: {
            ...mapActions("jianding", ["saveVideo"]),
            deleteVideo(index){
                if(this.videoList.length){
                    this.videoList.splice(index,1);
                    //this.uploaded.splice(index,1);
                    this.emitSuccess();
                }
            },
            oversize(){
                this.$toast({ message: "视频不可超过20M！" });
            },
            async videoRead(el,detail) {
                // 此时可以自行将文件上传至服务器
                console.log(el.target.files[0]);
                let file = el.target.files[0];
                let {videoList, videoMaxLength} = this;
                let vl = videoList.length;
                if(file.size > 20971520){
                    this.$toast("视频大小超过最大限制");
                    return
                }
                if(!/mp4/.test(file.type)){
                    this.$toast("请上传视频格式为mp4的文件");
                    return
                }
                //this.videoList.push(file.file);
                if(vl >= videoMaxLength){
                    this.$toast(`最多上传${this.videoList.length}个`)
                }else{
                    this.$toast.loading({message: '上传中...', duration: 0, forbidClick: true});
                    await this.saveVideo({
                        formId : 'js-uploader_form_videoRidFor'
                    }).then( R => {
                        let {videoUrl, videoExt} = R;
                        //this.uploaded.push(videoUrl||"");
                        this.videoList.push(videoUrl||"");
                        this.emitSuccess();
                        this.$toast.clear()
                    }).catch(err => {
                        this.$toast(err.message)
                    })

                }
            },
            emitSuccess(){
                this.$emit("success", {videos:this.videoList})
            }
        },
        watch : {
            list(nv){
                this.videoList = [...nv];
                console.log(nv)
            },
            /*uploaded(nv){
            },*/
            videoList(nv){
                this.uploaded = nv
                //this.$emit("success", {videos:nv});
            }
        }
    }
</script>

<style scoped>

</style>